/** Node-oriented deps (socket.io-client, simple-peer) expect `global` in the browser. */
const g = globalThis as typeof globalThis & { global?: typeof globalThis };
if (g.global === undefined) {
  g.global = globalThis;
}
